import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function PrivacyPolicyPage() {
  const {
    t
  } = useLanguage();
  return <div className="w-full bg-white min-h-screen pb-32" data-id="element-440">
      <div className="bg-corporate-dark text-white py-20 px-4" data-id="element-441">
        <div className="max-w-4xl mx-auto text-center mt-10" data-id="element-442">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-heading font-bold mb-6 tracking-tight" data-id="element-443">
            {t('footer.privacy')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-444">
            Información sobre cómo recopilamos, utilizamos y protegemos sus
            datos personales.
          </motion.p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-445">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-12" data-id="element-446">
          {/* Sección 1 */}
          <section data-id="element-447">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-448">
              1. Responsable del Tratamiento
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-449">
              <p data-id="element-450">
                <strong className="text-corporate-dark font-medium" data-id="element-451">
                  SmartImport Internacional
                </strong>{' '}
                es el responsable del tratamiento de los datos personales
                recogidos a través de este sitio web, de conformidad con lo
                dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo
                y del Consejo, de 27 de abril de 2016 (RGPD), relativo a la
                protección de las personas físicas en lo que respecta al
                tratamiento de datos personales.
              </p>
              <p data-id="element-452">
                Correo electrónico de contacto para asuntos de protección de
                datos:{' '}
                <strong className="text-corporate-dark font-medium" data-id="element-453">
                  info@smartimport.com
                </strong>
              </p>
            </div>
          </section>

          {/* Sección 2 */}
          <section data-id="element-454">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-455">
              2. Datos que Recopilamos
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-456">
              <p data-id="element-457">
                SmartImport Internacional puede recopilar datos personales a
                través de los siguientes medios:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-458">
                <li data-id="element-459">
                  <strong className="font-medium" data-id="element-460">
                    Formularios de contacto:
                  </strong>{' '}
                  Nombre, dirección de correo electrónico, número de teléfono,
                  nombre de la empresa y mensaje.
                </li>
                <li data-id="element-461">
                  <strong className="font-medium" data-id="element-462">
                    Comunicaciones por correo electrónico:
                  </strong>{' '}
                  Datos personales que el usuario proporcione voluntariamente al
                  contactar con nosotros.
                </li>
                <li data-id="element-463">
                  <strong className="font-medium" data-id="element-464">
                    Solicitudes de información:
                  </strong>{' '}
                  Datos necesarios para gestionar solicitudes de catálogos,
                  fichas técnicas o presupuestos.
                </li>
                <li data-id="element-465">
                  <strong className="font-medium" data-id="element-466">Datos de navegación:</strong>{' '}
                  Información técnica recopilada automáticamente como dirección
                  IP, tipo de navegador, páginas visitadas y tiempo de
                  permanencia (ver Política de Cookies).
                </li>
              </ul>
              <p data-id="element-467">
                En ningún caso se solicitarán datos personales sensibles. Los
                datos proporcionados por el usuario deben ser veraces, exactos y
                estar actualizados.
              </p>
            </div>
          </section>

          {/* Sección 3 */}
          <section data-id="element-468">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-469">
              3. Finalidad del Tratamiento
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-470">
              <p data-id="element-471">
                Los datos personales recogidos se utilizan para las siguientes
                finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-472">
                <li data-id="element-473">
                  Responder a consultas y solicitudes de información realizadas
                  por el usuario.
                </li>
                <li data-id="element-474">
                  Gestionar relaciones comerciales con distribuidores,
                  arquitectos y profesionales del sector.
                </li>
                <li data-id="element-475">
                  Enviar documentación técnica, catálogos y fichas de producto
                  solicitados.
                </li>
                <li data-id="element-476">
                  Remitir comunicaciones comerciales relacionadas con nuestros
                  productos y servicios, únicamente con el consentimiento previo
                  del usuario.
                </li>
                <li data-id="element-477">
                  Realizar análisis estadísticos anónimos para mejorar la
                  experiencia de navegación y los servicios ofrecidos.
                </li>
                <li data-id="element-478">Cumplir con las obligaciones legales aplicables.</li>
              </ul>
            </div>
          </section>

          {/* Sección 4 */}
          <section data-id="element-479">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-480">
              4. Base Legal del Tratamiento
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-481">
              <p data-id="element-482">El tratamiento de los datos personales se fundamenta en:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-483">
                <li data-id="element-484">
                  <strong className="font-medium" data-id="element-485">
                    Consentimiento del interesado:
                  </strong>{' '}
                  Cuando el usuario proporciona voluntariamente sus datos a
                  través de formularios o comunicaciones.
                </li>
                <li data-id="element-486">
                  <strong className="font-medium" data-id="element-487">
                    Ejecución de un contrato o precontrato:
                  </strong>{' '}
                  Cuando el tratamiento es necesario para gestionar solicitudes
                  comerciales o relaciones contractuales.
                </li>
                <li data-id="element-488">
                  <strong className="font-medium" data-id="element-489">Interés legítimo:</strong>{' '}
                  Para mantener y mejorar las relaciones comerciales con
                  distribuidores y profesionales del sector.
                </li>
              </ul>
            </div>
          </section>

          {/* Sección 5 */}
          <section data-id="element-490">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-491">
              5. Conservación de los Datos
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-492">
              <p data-id="element-493">
                Los datos personales se conservarán únicamente durante el tiempo
                necesario para cumplir con la finalidad para la que fueron
                recogidos. En particular:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-494">
                <li data-id="element-495">
                  Los datos de consultas se conservarán durante el tiempo
                  necesario para gestionar la solicitud y un período adicional
                  para atender posibles responsabilidades.
                </li>
                <li data-id="element-496">
                  Los datos de relaciones comerciales se mantendrán mientras
                  exista un interés mutuo en mantener dicha relación.
                </li>
                <li data-id="element-497">
                  Los datos para comunicaciones comerciales se conservarán hasta
                  que el usuario retire su consentimiento.
                </li>
              </ul>
              <p data-id="element-498">
                Una vez finalizado el período de conservación, los datos serán
                suprimidos o anonimizados de forma segura.
              </p>
            </div>
          </section>

          {/* Sección 6 */}
          <section data-id="element-499">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-500">
              6. Comunicación de Datos a Terceros
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-501">
              <p data-id="element-502">
                Los datos personales no serán cedidos a terceros, salvo
                obligación legal. En caso de que fuera necesario comunicar datos
                a terceros para la prestación de un servicio, se informará
                previamente al usuario y se solicitará su consentimiento cuando
                sea legalmente exigible.
              </p>
            </div>
          </section>

          {/* Sección 7 */}
          <section data-id="element-503">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-504">
              7. Derechos del Usuario
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-505">
              <p data-id="element-506">El usuario tiene derecho a:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-507">
                <li data-id="element-508">
                  <strong className="font-medium" data-id="element-509">Acceso:</strong> Conocer qué
                  datos personales estamos tratando.
                </li>
                <li data-id="element-510">
                  <strong className="font-medium" data-id="element-511">Rectificación:</strong>{' '}
                  Solicitar la corrección de datos inexactos o incompletos.
                </li>
                <li data-id="element-512">
                  <strong className="font-medium" data-id="element-513">Supresión:</strong> Solicitar
                  la eliminación de sus datos cuando ya no sean necesarios.
                </li>
                <li data-id="element-514">
                  <strong className="font-medium" data-id="element-515">Limitación:</strong> Solicitar
                  la limitación del tratamiento en determinadas circunstancias.
                </li>
                <li data-id="element-516">
                  <strong className="font-medium" data-id="element-517">Portabilidad:</strong> Recibir
                  sus datos en un formato estructurado y de uso común.
                </li>
                <li data-id="element-518">
                  <strong className="font-medium" data-id="element-519">Oposición:</strong> Oponerse
                  al tratamiento de sus datos en determinadas circunstancias.
                </li>
                <li data-id="element-520">
                  <strong className="font-medium" data-id="element-521">
                    Retirada del consentimiento:
                  </strong>{' '}
                  Retirar el consentimiento otorgado en cualquier momento.
                </li>
              </ul>
              <p data-id="element-522">
                Para ejercer cualquiera de estos derechos, el usuario puede
                dirigirse a{' '}
                <strong className="text-corporate-dark font-medium" data-id="element-523">
                  info@smartimport.com
                </strong>
                , indicando el derecho que desea ejercer y acompañando una copia
                de su documento de identidad.
              </p>
              <p data-id="element-524">
                Asimismo, el usuario tiene derecho a presentar una reclamación
                ante la autoridad de control competente en materia de protección
                de datos si considera que el tratamiento de sus datos no se
                ajusta a la normativa vigente.
              </p>
            </div>
          </section>

          {/* Sección 8 */}
          <section data-id="element-525">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-526">
              8. Medidas de Seguridad
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-527">
              <p data-id="element-528">
                SmartImport Internacional implementa medidas técnicas y
                organizativas adecuadas para garantizar la seguridad de los
                datos personales y evitar su alteración, pérdida, tratamiento o
                acceso no autorizado, teniendo en cuenta el estado de la
                tecnología, la naturaleza de los datos almacenados y los riesgos
                a que están expuestos.
              </p>
              <p data-id="element-529">
                Entre las medidas adoptadas se incluyen el cifrado de
                comunicaciones, controles de acceso, copias de seguridad
                periódicas y formación del personal en materia de protección de
                datos.
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12" data-id="element-530">
            <p className="text-sm text-gray-400 font-light" data-id="element-531">
              Última actualización: Marzo 2026
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}